<div class="referee-container" [class.light-theme]="!isDarkTheme" *ngIf="match && localState">
  <!-- HEADER -->
  <div class="referee-header">
    <div class="header-left">
      <span class="header-logo">
        <img [src]="isDarkTheme ? 'images/opensquash/sponsors/logo-bolar-white.png' : 'images/opensquash/sponsors/bolar-logo.png'" alt="Logo Bolar" class="logo">
      </span>
    </div>
    <div class="header-center">
      <div class="game-indicator">JUEGO {{ localState.currentGame + 1 }}</div>
      <div class="games-score">{{ getGamesWonDisplay() }}</div>
    </div>
    <div class="header-right">
      <div class="header-right-badges">
        <div class="match-category-badge" *ngIf="match.category">{{ match.category | titlecase }}</div>
        <div class="match-format-badge">Bo{{ localState.bestOf }} · {{ localState.pointsToWin }}pts</div>
      </div>
      <button class="header-theme-toggle" (click)="toggleTheme()">
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>
    </div>
  </div>

  <!-- RANDOM ANIMATION OVERLAY -->
  <div class="random-animation-overlay" *ngIf="showingRandomAnimation">
    <div class="random-animation-content">
      <h2 class="random-title" [class.revealed]="randomAnimationResult !== null">
        {{ randomAnimationResult === null ? '¡SORTEANDO!' : '¡RESULTADO!' }}
      </h2>

      <!-- Sorteo de Moneda -->
      <div class="coin-container">
        <div class="coin"
             [class.reveal-player1]="randomAnimationResult === 1"
             [class.reveal-player2]="randomAnimationResult === 2">
          <!-- Cara frontal: Player 1 -->
          <div class="coin-face coin-front" [style.borderColor]="localState.player1Color">
            <div class="coin-initials" [style.color]="localState.player1Color">
              {{ getInitials(match.player1?.playerName || 'J1') }}
            </div>
            <div class="coin-label">{{ match.player1?.playerName || 'Jugador 1' }}</div>
          </div>

          <!-- Cara trasera: Player 2 -->
          <div class="coin-face coin-back" [style.borderColor]="localState.player2Color">
            <div class="coin-initials" [style.color]="localState.player2Color">
              {{ getInitials(match.player2?.playerName || 'J2') }}
            </div>
            <div class="coin-label">{{ match.player2?.playerName || 'Jugador 2' }}</div>
          </div>
        </div>
      </div>

      <!-- Indicadores de jugadores -->
      <div class="player-indicators">
        <div class="indicator indicator-left" [class.selected]="randomAnimationResult === 1">
          <div class="indicator-avatar" [style.borderColor]="localState.player1Color">
            <span>{{ getInitials(match.player1?.playerName || 'J1') }}</span>
          </div>
        </div>

        <div class="indicator indicator-right" [class.selected]="randomAnimationResult === 2">
          <div class="indicator-avatar" [style.borderColor]="localState.player2Color">
            <span>{{ getInitials(match.player2?.playerName || 'J2') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- WARMUP PHASE -->
  <div class="warmup-phase" *ngIf="localState.phase === 'WARMUP'">
    <div class="warmup-content">

      <!-- PRE-WARMUP: Calentamiento aún no iniciado -->
      <ng-container *ngIf="!localState.warmupStartTs">
        <h2>PARTIDO LISTO</h2>

        
        <div class="match-format-info">
          <span>Al mejor de {{ localState.bestOf }} juegos</span>
          <span class="format-separator">·</span>
          <span>{{ localState.pointsToWin }} puntos por juego</span>
        </div>
        
        <div class="match-category-label" *ngIf="match.category">{{ match.category | titlecase }}</div>
        
        <!-- Avatares de jugadores (clickeables para cambiar color) -->
        <div class="warmup-players">
          <!-- Player 1 -->
          <div class="warmup-player-container">
            <div class="warmup-avatar-wrapper" (click)="openColorPicker(1)">
              <div class="warmup-avatar" [style.borderColor]="localState.player1Color">
                <img *ngIf="match.player1?.photoURL"
                     [src]="match.player1?.photoURL"
                     [alt]="match.player1?.playerName"
                     class="avatar-image">
                <span *ngIf="!match.player1?.photoURL" class="initials">
                  {{ getInitials(match.player1?.playerName || 'J1') }}
                </span>
              </div>
              <div class="edit-color-hint">
                <mat-icon>palette</mat-icon>
              </div>
            </div>
            <div class="warmup-player-name">{{ match.player1?.playerName || 'Jugador 1' }}</div>
          </div>

          <!-- VS -->
          <div class="warmup-vs">VS</div>

          <!-- Player 2 -->
          <div class="warmup-player-container">
            <div class="warmup-avatar-wrapper" (click)="openColorPicker(2)">
              <div class="warmup-avatar" [style.borderColor]="localState.player2Color">
                <img *ngIf="match.player2?.photoURL"
                     [src]="match.player2?.photoURL"
                     [alt]="match.player2?.playerName"
                     class="avatar-image">
                <span *ngIf="!match.player2?.photoURL" class="initials">
                  {{ getInitials(match.player2?.playerName || 'J2') }}
                </span>
              </div>
              <div class="edit-color-hint">
                <mat-icon>palette</mat-icon>
              </div>
            </div>
            <div class="warmup-player-name">{{ match.player2?.playerName || 'Jugador 2' }}</div>
          </div>
        </div>

        <div class="warmup-timer">
          <div class="timer-display timer-paused">{{ formatTime(getWarmupTimeRemaining()) }}</div>
        </div>

        <button mat-raised-button
                class="start-warmup-btn"
                (click)="startWarmup()">
          <mat-icon>timer</mat-icon>
          Iniciar Calentamiento
        </button>
      </ng-container>

      <!-- WARMUP EN CURSO: Timer corriendo -->
      <ng-container *ngIf="localState.warmupStartTs">
        <h2>CALENTAMIENTO EN PROGRESO</h2>

        <div class="match-format-info">
          <span>Al mejor de {{ localState.bestOf }} juegos</span>
          <span class="format-separator">·</span>
          <span>{{ localState.pointsToWin }} puntos por juego</span>
        </div>

        <div class="warmup-timer">
          <div class="timer-display">{{ formatTime(getWarmupTimeRemaining()) }}</div>
          <mat-progress-bar mode="determinate" [value]="warmupProgress"></mat-progress-bar>
        </div>

        <h3>Selecciona quién sirve primero</h3>

        <!-- Avatares de jugadores (clickeables para cambiar color) -->
        <div class="warmup-players">
          <!-- Player 1 -->
          <div class="warmup-player-container">
            <div class="warmup-player-name">{{ match.player1?.playerName || 'Jugador 1' }}</div>
            <div class="warmup-player-row">
              <div class="warmup-avatar-wrapper" (click)="openColorPicker(1)">
                <div class="warmup-avatar" [style.borderColor]="localState.player1Color">
                  <img *ngIf="match.player1?.photoURL"
                       [src]="match.player1?.photoURL"
                       [alt]="match.player1?.playerName"
                       class="avatar-image">
                  <span *ngIf="!match.player1?.photoURL" class="initials">
                    {{ getInitials(match.player1?.playerName || 'J1') }}
                  </span>
                </div>
                <div class="edit-color-hint">
                  <mat-icon>palette</mat-icon>
                </div>
              </div>
              <button mat-raised-button
                      class="warmup-serve-btn"
                      [style.backgroundColor]="localState.player1Color"
                      (click)="selectServer(1)">
                <mat-icon>sports_tennis</mat-icon>
                Sirve
              </button>
            </div>
          </div>

          <!-- Player 2 -->
          <div class="warmup-player-container">
            <div class="warmup-player-name">{{ match.player2?.playerName || 'Jugador 2' }}</div>
            <div class="warmup-player-row">
              <div class="warmup-avatar-wrapper" (click)="openColorPicker(2)">
                <div class="warmup-avatar" [style.borderColor]="localState.player2Color">
                  <img *ngIf="match.player2?.photoURL"
                       [src]="match.player2?.photoURL"
                       [alt]="match.player2?.playerName"
                       class="avatar-image">
                  <span *ngIf="!match.player2?.photoURL" class="initials">
                    {{ getInitials(match.player2?.playerName || 'J2') }}
                  </span>
                </div>
                <div class="edit-color-hint">
                  <mat-icon>palette</mat-icon>
                </div>
              </div>
              <button mat-raised-button
                      class="warmup-serve-btn"
                      [style.backgroundColor]="localState.player2Color"
                      (click)="selectServer(2)">
                <mat-icon>sports_tennis</mat-icon>
                Sirve
              </button>
            </div>
          </div>
        </div>

        <button mat-stroked-button
                class="random-btn"
                (click)="randomServer()">
          <mat-icon>shuffle</mat-icon>
          Sorteo Aleatorio
        </button>
      </ng-container>
    </div>
  </div>

  <!-- PLAYING PHASE -->
  <div class="playing-phase" *ngIf="localState.phase === 'PLAYING'">
    <!-- SECTION 1: SCOREBOARD (Avatares + Scores) -->
    <div class="scoreboard-section">
      <div class="main-scoreboard">
        <!-- Player 1 Section -->
        <div class="player-section player-1">
          <div class="player-info">
            <div class="player-avatar-wrapper">
              <!-- Botón L (izquierda del avatar) -->
              <button *ngIf="localState.server === 1"
                      class="serve-box-btn serve-box-left"
                      [class.filled]="getServeBoxState('L') === 'filled'"
                      [class.outline]="getServeBoxState('L') === 'outline'"
                      [class.disabled]="getServeBoxState('L') === 'disabled'"
                      [disabled]="getServeBoxState('L') === 'disabled'"
                      [ngStyle]="getServeBoxStyles(1, getServeBoxState('L'))"
                      (click)="changeServeBox('L')">
                L
              </button>

              <!-- Avatar -->
              <div class="player-avatar player-1-avatar"
                   (click)="openColorPicker(1)"
                   [style.borderColor]="localState.player1Color">
                <img *ngIf="match.player1?.photoURL"
                     [src]="match.player1?.photoURL"
                     [alt]="match.player1?.playerName"
                     class="avatar-image">
                <span *ngIf="!match.player1?.photoURL" class="initials">
                  {{ getInitials(match.player1?.playerName || 'J1') }}
                </span>
              </div>

              <!-- Botón R (derecha del avatar) -->
              <button *ngIf="localState.server === 1"
                      class="serve-box-btn serve-box-right"
                      [class.filled]="getServeBoxState('R') === 'filled'"
                      [class.outline]="getServeBoxState('R') === 'outline'"
                      [class.disabled]="getServeBoxState('R') === 'disabled'"
                      [disabled]="getServeBoxState('R') === 'disabled'"
                      [ngStyle]="getServeBoxStyles(1, getServeBoxState('R'))"
                      (click)="changeServeBox('R')">
                R
              </button>
            </div>
            <div class="player-name">{{ player1ShortName }}</div>
          </div>
          <div class="player-score">{{ currentGameDetail?.player1Points || 0 }}</div>
        </div>

        <!-- Spacer for center line -->
        <div class="center-spacer"></div>

        <!-- Player 2 Section -->
        <div class="player-section player-2">
          <div class="player-info">
            <div class="player-avatar-wrapper">
              <!-- Botón L (izquierda del avatar) -->
              <button *ngIf="localState.server === 2"
                      class="serve-box-btn serve-box-left"
                      [class.filled]="getServeBoxState('L') === 'filled'"
                      [class.outline]="getServeBoxState('L') === 'outline'"
                      [class.disabled]="getServeBoxState('L') === 'disabled'"
                      [disabled]="getServeBoxState('L') === 'disabled'"
                      [ngStyle]="getServeBoxStyles(2, getServeBoxState('L'))"
                      (click)="changeServeBox('L')">
                L
              </button>

              <!-- Avatar -->
              <div class="player-avatar player-2-avatar"
                   (click)="openColorPicker(2)"
                   [style.borderColor]="localState.player2Color">
                <img *ngIf="match.player2?.photoURL"
                     [src]="match.player2?.photoURL"
                     [alt]="match.player2?.playerName"
                     class="avatar-image">
                <span *ngIf="!match.player2?.photoURL" class="initials">
                  {{ getInitials(match.player2?.playerName || 'J2') }}
                </span>
              </div>

              <!-- Botón R (derecha del avatar) -->
              <button *ngIf="localState.server === 2"
                      class="serve-box-btn serve-box-right"
                      [class.filled]="getServeBoxState('R') === 'filled'"
                      [class.outline]="getServeBoxState('R') === 'outline'"
                      [class.disabled]="getServeBoxState('R') === 'disabled'"
                      [disabled]="getServeBoxState('R') === 'disabled'"
                      [ngStyle]="getServeBoxStyles(2, getServeBoxState('R'))"
                      (click)="changeServeBox('R')">
                R
              </button>
            </div>
            <div class="player-name">{{ player2ShortName }}</div>
          </div>
          <div class="player-score">{{ currentGameDetail?.player2Points || 0 }}</div>
        </div>
      </div>
    </div>

    <!-- SECTION 2: ACTIONS (Botones + Rally History) -->
    <div class="actions-section">
      <div class="actions-grid">
        <!-- Player 1 Actions (Left Column) -->
        <div class="player-actions player-1-actions">
          <button class="action-btn btn-win"
                  [style.borderColor]="getActionButtonBorderColor(1)"
                  [style.backgroundColor]="getActionButtonBorderColor(1) + '4D'"
                  (click)="pointTo(1)">Gana Punto</button>
          <button class="action-btn btn-let" [style.borderColor]="getActionButtonBorderColor(1)" (click)="letCall(1)">LET</button>
          <button class="action-btn btn-no-let" [style.borderColor]="getActionButtonBorderColor(1)" (click)="noLet(1)">NO LET</button>
          <button class="action-btn btn-stroke" [style.borderColor]="getActionButtonBorderColor(1)" (click)="stroke(1)">STROKE</button>
        </div>

        <!-- Rally History (Center Column) -->
        <div class="rally-history-container">
          <div *ngFor="let rally of getRallyHistory()"
               class="rally-badge"
               [ngClass]="{
                 'rally-left': rally.serverPlayer === 1,
                 'rally-right': rally.serverPlayer === 2
               }"
               [style.backgroundColor]="getRallyBadgeColor(rally)"
               [style.color]="getRallyBadgeTextColor(rally)">
            <span class="rally-content">{{ rally.displayText }}</span>
          </div>
        </div>

        <!-- Player 2 Actions (Right Column) -->
        <div class="player-actions player-2-actions">
          <button class="action-btn btn-win"
                  [style.borderColor]="getActionButtonBorderColor(2)"
                  [style.backgroundColor]="getActionButtonBorderColor(2) + '4D'"
                  (click)="pointTo(2)">Gana Punto</button>
          <button class="action-btn btn-let" [style.borderColor]="getActionButtonBorderColor(2)" (click)="letCall(2)">LET</button>
          <button class="action-btn btn-no-let" [style.borderColor]="getActionButtonBorderColor(2)" (click)="noLet(2)">NO LET</button>
          <button class="action-btn btn-stroke" [style.borderColor]="getActionButtonBorderColor(2)" (click)="stroke(2)">STROKE</button>
        </div>
      </div>
    </div>
  </div>

  <!-- REST PHASE -->
  <div class="rest-phase" *ngIf="localState.phase === 'REST'">
    <div class="rest-content">
      <h2>DESCANSO ENTRE JUEGOS</h2>

      <div class="rest-info">
        <p>Juego {{ currentGameDetail?.number }} finalizado</p>
        <p class="rest-score">
          {{ player1ShortName }} : {{ currentGameDetail?.player1Points }} - {{ currentGameDetail?.player2Points }} : {{ player2ShortName }}
        </p>
      </div>

      <div class="rest-timer">
        <div class="timer-display">{{ formatTime(getRestTimeRemaining()) }}</div>
        <mat-progress-bar mode="determinate" [value]="restProgress"></mat-progress-bar>
      </div>

      <p *ngIf="localState.server">
        Sirve: {{ localState.server === 1 ? player1ShortName : player2ShortName }}
      </p>

      <button mat-raised-button
              color="primary"
              class="start-next-game-btn"
              (click)="startNextGame()">
        Iniciar Juego {{ localState.currentGame + 2 }} Ahora
      </button>
    </div>
  </div>

  <!-- FINISHED PHASE -->
  <div class="finished-phase" *ngIf="localState.phase === 'FINISHED'">
    <div class="finished-content">
      <h2>¡PARTIDO FINALIZADO!</h2>

      <div class="winner-display">
        <h3>Ganador: {{ countGamesWon()[1] > countGamesWon()[2] ? match.player1?.playerName : match.player2?.playerName }}</h3>
      </div>

      <div class="final-score">
        <p>Score final: {{ getGamesWonDisplay() }}</p>
      </div>

      <div class="match-stats">
        <div *ngFor="let game of localState.games" class="game-summary">
          <span>Juego {{ game.number }}: </span>
          <span>{{ game.player1Points }} - {{ game.player2Points }}</span>
          <span *ngIf="game.winner"> (Ganador: J{{ game.winner }})</span>
        </div>
      </div>

      <!-- Guardando -->
      <p class="saving-message" *ngIf="!matchSavedSuccessfully && !syncError && isSyncing">
        <mat-spinner diameter="20"></mat-spinner>
        Guardando partido...
      </p>

      <!-- Éxito -->
      <p class="success-message" *ngIf="matchSavedSuccessfully">
        <mat-icon>check_circle</mat-icon>
        ¡Partido guardado exitosamente!
      </p>

      <!-- Error de sincronización -->
      <div class="sync-error-container" *ngIf="syncError && !matchSavedSuccessfully">
        <div class="sync-error-message">
          <mat-icon>wifi_off</mat-icon>
          <span>Sin conexión. El partido está guardado localmente.</span>
        </div>
        <button mat-raised-button
                class="sync-retry-btn"
                [disabled]="isSyncing"
                (click)="retrySyncMatch()">
          <mat-icon>sync</mat-icon>
          {{ isSyncing ? 'Sincronizando...' : 'Sincronizar ahora' }}
        </button>
      </div>
    </div>
  </div>

  <!-- FOOTER (Always visible except in WARMUP) -->
  <div class="referee-footer" *ngIf="localState.phase !== 'WARMUP'">
    <div class="undo-section" *ngIf="localState.phase !== 'REST' && localState.phase !== 'FINISHED'">
        <button class="undo-btn"
                (click)="undo()"
                [disabled]="!currentGameDetail || currentGameDetail.events.length === 0">
          <mat-icon>undo</mat-icon>
        </button>
      </div>
    <div class="footer-timer">
      <div class="timer-label">Tiempo Partido</div>
      <div class="timer-value">{{ matchElapsedTime }}</div>
    </div>
    <div class="footer-timer">
      <div class="timer-label">Tiempo Juego</div>
      <div class="timer-value">{{ gameElapsedTime }}</div>
    </div>
  </div>
</div>

<!-- Loading State -->
<div class="loading-container" [class.light-theme]="!isDarkTheme" *ngIf="!match && !showErrorState">
  <mat-spinner></mat-spinner>
  <p>Cargando partido...</p>
</div>

<!-- Error State -->
<div class="error-state-container" [class.light-theme]="!isDarkTheme" *ngIf="showErrorState && match">
  <!-- HEADER -->
  <div class="referee-header">
    <div class="header-left">
      <span class="header-logo">
        <img [src]="isDarkTheme ? 'images/opensquash/sponsors/logo-bolar-white.png' : 'images/opensquash/sponsors/bolar-logo.png'" alt="Logo Bolar" class="logo">
      </span>
    </div>
    <div class="header-center">
      <div class="game-indicator">{{ errorTitle }}</div>
    </div>
    <button class="header-theme-toggle" (click)="toggleTheme()">
      <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
  </div>

  <!-- ERROR CONTENT -->
  <div class="error-content">
    <div class="error-icon">
      <mat-icon>warning</mat-icon>
    </div>
    <h2>{{ errorTitle }}</h2>
    <p class="error-message">{{ errorMessage }}</p>

    <div class="match-info">
      <p class="info-label">Partido:</p>
      <p class="info-value">{{ match.player1?.playerName }} vs {{ match.player2?.playerName }}</p>
    </div>

    <button mat-raised-button class="back-btn" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  </div>
</div>
